import BaseGameInformation from '#GameFrontend/authorized/components/ui/BaseGameInformation';
import BottomBar from '#GameFrontend/authorized/components/ui/BottomBar';
import ResourceBar from '#GameFrontend/authorized/components/ui/ResourceBar';
import { CandoIcon, GoldenHorseshoeIcon } from '#GameFrontend/authorized/components/bank/CurrencyIcons';
import { useBank } from '#GameFrontend/contexts/BankContext';
import { useFilter } from '#GameFrontend/contexts/FilterContext';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import ProgressAvatar from './ui/ProgressAvatar';

const Layout: React.FC = () => {
	const { balances } = useBank();
	const [date, setDate] = useState('14. Dezember');
	const [time, setTime] = useState('13:12');
	const { t } = useTranslation();
	const filter = useFilter();
	const location = useLocation();
	const isHorseView = location.pathname.includes('/horse/view/');
	const candoLabel = t('bank.cando.title');
	const horseshoeLabel = t('bank.horseshoe.title');

	return (
		<main className={`relative flex flex-col h-screen overflow-y-auto ${isHorseView ? 'horse-view-page ' : ''}`}>
			{/* Fixed top section */}
			<div className="relative z-10 flex-shrink-0">
				{/* Mobile Layout */}
				<div className="lg:hidden">
					{/* Main container with grid */}
					<div className="grid grid-cols-[15%_85%] w-full">
						{/* Column 1: Avatar */}
						<div className="relative -mt-2 -ml-4 z-50">
							<ProgressAvatar
								size={80}
								progress={63}
								level={1}
								gradientId="layoutProgressGradient"
								levelPosition="bottom-right"
							/>
						</div>
						<div className="flex items-center">
							<div className="grid grid-cols-[42%_35%_24%] wood-dark h-8 -ml-2 pl-8 w-dvw">
								{/* Column 2 & 3: Resource bars */}
								<ResourceBar
									color="gray-400"
									value={balances.cando}
									icon={<CandoIcon title={candoLabel} />}
									link="/bank/cando"
									showBackground={false}
								/>
								<ResourceBar
									color="amber-600"
									value={balances.horseshoe}
									icon={<GoldenHorseshoeIcon title={horseshoeLabel} />}
									link="/bank/horseshoe"
									showBackground={false}
								/>
								{/* Column 4: Game information - spans full width */}
								<BaseGameInformation showBackground={false} />
							</div>
						</div>
					</div>
				</div>

				{/* Desktop Layout */}
				<div className="hidden lg:block">
					<div className="flex justify-between">
						{/* Resource bars */}
						<div className="flex flex-col gap-3 min-w-24 md:min-w-48 lg:pt-4">
							<ResourceBar
								color="gray-400"
								value={balances.cando}
								icon={<CandoIcon title={candoLabel} />}
								link="/bank/cando"
								showBackground={true}
							/>
							<ResourceBar
								color="amber-600"
								value={balances.horseshoe}
								icon={<GoldenHorseshoeIcon title={horseshoeLabel} />}
								link="/bank/horseshoe"
								showBackground={true}
							/>
						</div>

						{/* Filter Component Area */}
						<div
							className={`flex-col gap-2 w-1/2 items-center justify-top hidden ${filter.filterComponent ? 'lg:flex' : ''} lg:pt-0 lg:mt-0`}
						>
							{filter.filterComponent}
						</div>

						{/* Date and time */}
						<div className="flex items-start gap-2 text-white lg:pt-4">
							<BaseGameInformation showBackground={true} />
						</div>
					</div>

					{/* Left navigation menu - Absolutely positioned */}
					<div className="absolute left-4 top-full z-50">
						<div className="rounded-b-md p-4 bg-amber-100 bg-opacity-25 shadow-md w-40 text-white text-xs text-center z-50">
							{t('notifications.none')}
						</div>
					</div>
				</div>
			</div>

			{/* Main content area */}
			<div className="relative z-10 flex min-h-0 flex-1">
				{/* Content area */}
				<div className="flex-1">
					<div className="pt-2">
						<div className="mx-auto">
							<Outlet />
						</div>
					</div>
				</div>
			</div>

			{/* Fixed bottom section */}
			<div className="relative z-10 flex-shrink-0">
				<BottomBar />
			</div>
		</main>
	);
};

export default Layout;
